"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasOwnProperty = void 0;
const hasOwnProperty = (obj, prop) => {
    // had to add these typeof checks because storybook is a terrible piece of software
    return typeof obj === 'object' && typeof prop === 'string' && prop in obj;
};
exports.hasOwnProperty = hasOwnProperty;
